const PROPERTY_RELATIONS = [
  'financovane_nehnutelnosti',
  'zakladane_nehnutelnosti',
  'suvisiace_nehnutelnosti',
  'available_property_ids',
];

function clientPropertyIds(client) {
  const mortgages = Array.isArray(client?.mortgages) ? client.mortgages : [];
  return [...new Set(mortgages.flatMap(mortgage => PROPERTY_RELATIONS.flatMap(key => {
    const properties = Array.isArray(mortgage?.[key]) ? mortgage[key] : [];
    return properties.map(property => Number(property?.id ?? property))
      .filter(id => Number.isSafeInteger(id) && id > 0);
  })))];
}

function normalizeDistrict(value) {
  if (typeof value !== 'string') return '';
  return value.trim().replace(/^(?:okres|district)\s+/i, '')
    .replace(/\s+(?:okres|district)$/i, '').replace(/\s+/g, ' ').trim();
}

function clientDistricts(client, districtsByProperty) {
  const names = new Map();
  for (const id of clientPropertyIds(client)) {
    const name = normalizeDistrict(districtsByProperty[id]);
    if (name) names.set(name.toLocaleLowerCase('sk'), name);
  }
  return [...names.values()].sort((a, b) => a.localeCompare(b, 'sk'));
}

async function loadPropertyDistricts(clients, fetchProperties) {
  const ids = [...new Set(clients.flatMap(clientPropertyIds))];
  const districts = {};
  // The property endpoint caps pages at 20, regardless of requested page_size.
  for (let offset = 0; offset < ids.length; offset += 20) {
    const batch = ids.slice(offset, offset + 20);
    batch.forEach(id => { districts[id] = ''; });
    try {
      const response = await fetchProperties(batch);
      for (const property of response.results || []) {
        if (batch.includes(property.id)) {
          districts[property.id] = normalizeDistrict(property.address_text_district);
        }
      }
    } catch (error) {
      // Districts are optional: a failed lookup must not hide the client list
      // or retain an older district. A list refresh retries the lookup.
    }
  }
  return districts;
}

module.exports = {clientPropertyIds, clientDistricts, loadPropertyDistricts};
